import React from 'react'
import { Link, Badge, Typography, styled } from '@mui/material'
import PropTypes from 'prop-types'

const StyledLink = styled(Link)(({ active, height }) => ({
    height: height,
    border: active ? 'solid 2px #0057A0' : 'solid 2px #d2d2d9',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    position: 'relative',
    '& span.MuiBadge-root': {
        position: 'absolute',
        width: '100%',
        top: '5px',
        right: '5px',
        transform: 'none',
    },
    '& span.MuiBadge-badge': {
        backgroundColor: !active ? '#848992' : '#0057A0',
        transform: 'none',
    },
    '&:hover': {
        border: 'solid 2px #0057A0',
        '& span.MuiBadge-badge': {
            backgroundColor: '#0057A0',
        },
        '& svg': {
            color: '#848992',
        },
    },
}))

const StyledLabel = styled(Typography)(({ showLabelWithin }) => ({
    wordBreak: 'break-word',
    marginTop: '15px',
    fontSize: showLabelWithin ? '16px' : '20px',
    maxWidth: showLabelWithin && '100%',
    padding: '0px 6px',
    color: '#848992',
    textAlign: 'center',
    lineHeight: 'normal',
}))

const LinkTile = ({
    active,
    height,
    icon,
    onClick,
    label,
    showLabelWithin,
    count,
}) => {
    return (
        <>
            <StyledLink
                active={active}
                height={height}
                underline="none"
                onClick={onClick}
            >
                {count && (
                    <Badge color="primary" max={9999} badgeContent={count} />
                )}
                {icon}
                {showLabelWithin && (
                    <StyledLabel
                        variant="body1"
                        showLabelWithin={showLabelWithin}
                    >
                        {label}
                    </StyledLabel>
                )}
            </StyledLink>
            {!showLabelWithin && (
                <StyledLabel variant="body1" showLabelWithin={showLabelWithin}>
                    {label}
                </StyledLabel>
            )}
        </>
    )
}

LinkTile.propTypes = {
    active: PropTypes.bool,
    showLabelWithin: PropTypes.bool,
    icon: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    height: PropTypes.string,
}

LinkTile.defaultProps = {
    active: false,
    showLabelWithin: false,
    height: '180px',
}

export default LinkTile
